/**
 * 接口根地址（与 axios baseURL、静态资源域名一致，改一处全局生效）
 * 可在项目根目录 .env 里设置：VUE_APP_API_BASE=http://你的接口域名
 */
const raw = process.env.VUE_APP_API_BASE || 'http://api.qyz.com'
export const API_BASE = String(raw).replace(/\/$/, '')

/** 文件存储访问根路径，末尾带 / */
// 你的后端实际图片访问地址是 `${API_BASE}/uploads/...`（而不是 `${API_BASE}/storage/uploads/...`）
// 因此此处不要再额外拼一层 /storage，避免富文本图片 404。
export const STORAGE_BASE = `${API_BASE}/`
